import { render, staticRenderFns } from "./WithdrawalSettings.vue?vue&type=template&id=15ff3573&scoped=true"
import script from "./WithdrawalSettings.vue?vue&type=script&lang=js"
export * from "./WithdrawalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ff3573",
  null
  
)

export default component.exports